import React from 'react';
import { Helmet } from 'react-helmet';

import { cn } from 'utils/cn';

interface PageProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
  id?: string;
  dataCy?: string;
}

export function Page(props: PageProps) {
  return (
    <div
      className={cn('h-full w-full', props.className)}
      id={props.id}
      data-cy={props.dataCy}
    >
      <Helmet>
        <title>{props.title}</title>
        <meta name="description" content={props.description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      {props.children}
    </div>
  );
}
